import React from 'react'
import type { OperationalSummaryRow } from '../../services/informationSystemOperationalApi'
import {
  resolveAuditReadiness,
  formatStandardLabel,
  type AuditReadinessModel,
} from './auditReadinessModel'
import { useOrgAuditReadinessInputs } from './AuditReadinessContext'

export function useAuditReadiness(row: OperationalSummaryRow): AuditReadinessModel {
  const inputs = useOrgAuditReadinessInputs()
  return React.useMemo(() => resolveAuditReadiness(row, inputs), [row, inputs])
}

export function useAuditReadinessSourceLabel(
  model: AuditReadinessModel,
  t: (key: string, fallback?: string, opts?: Record<string, unknown>) => string
): string {
  return React.useMemo(() => {
    if (model.sourceType === 'SELF_ASSESSMENT' && model.sourceStandard) {
      return t('assets.auditReadiness.source.selfAssessment', 'Derived from {{standard}} self-assessment', {
        standard: formatStandardLabel(model.sourceStandard),
      })
    }
    if (model.sourceType === 'VERIFIED_AUDIT' && model.sourceStandard) {
      return t('assets.auditReadiness.source.verifiedAudit', 'Derived from verified {{standard}} audit', {
        standard: formatStandardLabel(model.sourceStandard),
      })
    }
    if (model.sourceType === 'ORG_SECURITY_HEALTH') {
      return t(
        'assets.auditReadiness.source.orgSecurityHealth',
        'Derived from organization Total Security Health'
      )
    }
    return t('assets.auditReadiness.source.unknown', 'No system-specific compliance score available')
  }, [model, t])
}
